
import {
  PERMISSION_GRANTED,
  PERMISSION_DENIED,
  POSITION_UNAVAILABLE,
  TIMEOUT,
  UNKNOWN_ERROR
} from './constant'

function checkGeolocationSupport() {
  return ("geolocation" in navigator)
}

function handleGeolocationError(error) {
  switch(error.code) {
    case error.PERMISSION_DENIED:
      return { code: PERMISSION_DENIED, message: "L'utilisateur a refusé la demande de géolocalisation" }
    case error.POSITION_UNAVAILABLE:
      return { code: POSITION_UNAVAILABLE, message: "Les informations de localisation sont indisponibles" }
    case error.TIMEOUT:
      return { code: TIMEOUT, message: "La demande de localisation a expiré" }
    case error.UNKNOWN_ERROR:
      return { code: UNKNOWN_ERROR, message: "Une erreur inconnue s'est produite" }
  }
}

export function requestGeolocation(options) {
  const defaultOptions = { enableHighAccuracy: true, timeout: 7500, maximumAge: 1000 }

  return new Promise((resolve, reject) => {
    if (checkGeolocationSupport()) {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          const { latitude, longitude } = position.coords;
          resolve({ status: "success", code: PERMISSION_GRANTED, latitude, longitude })
        },
        (error) => {
          const { message, code } = handleGeolocationError(error);
          reject({ status: "error", message, code })
        },
        { ...defaultOptions, ...options }
      );
    }
    else reject({ status: "error", message: "Fonctionnalité non supporté par votre navigateur" })
  });
}